import { useState, useEffect, useRef } from "react";
import moment from "moment";
import { OverlayTrigger, Button, Popover as BootstrapPopover } from "react-bootstrap";
import styled from "styled-components";

const StyledPopover = styled(BootstrapPopover)`
    padding: 16px;
    background-color: #f8f9fa;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    width: 250px;

    .popover-body {
        font-size: 14px;
        color: #333;
    }

    .popover-header {
        font-weight: bold;
        padding-bottom: 8px;
        border-bottom: 2px solid #ddd;
        margin-bottom: 10px;
    }
`;

const StyledIcon = styled.i`
    background-color: #7590ae;
    width: 13px;
    height: 13px;
    text-align: center;
    border-radius: 50%;
    font-size: 7px;
    line-height: 13px;
    color: #fff;
    margin-left: 4px;
    margin-top: -1px;
    cursor: pointer;
`;

export const DatePopup = ({ dateRange, dollar }) => {
    const [amountDetails, setAmountDetails] = useState({
        perDayAmount: 0,
        totalDays: 0,
        amountByYear: {}
    });
    const [showPopover, setShowPopover] = useState(false);
    const popoverRef = useRef(null);

    const calculateDaysInYear = (startDate, endDate, year) => {
        const start = moment(startDate);
        const end = moment(endDate);

        const yearStart = moment(`${year}-01-01`);
        const yearEnd = moment(`${year}-12-31`);

        const adjustedStart = start.isBefore(yearStart) ? yearStart : start;
        const adjustedEnd = end.isAfter(yearEnd) ? yearEnd : end;

        return Math.max(0, adjustedEnd.diff(adjustedStart, "days") + 1);
    };
    const calculateAmounts = () => {
        const match = dateRange.match(/\((.*?)\)/);

        if (!match || match[1] === undefined) {
            console.error("Invalid date range format:", dateRange);
            return;
        }

        const [startDate, endDate] = match[1].split(" - ");

        const totalDays = moment(endDate).diff(moment(startDate), "days") + 1;

        const perDayAmount = dollar / totalDays;

        const yearRange = [];
        let startYear = moment(startDate).year();
        let endYear = moment(endDate).year();

        for (let year = startYear; year <= endYear; year++) {
            const daysInYear = calculateDaysInYear(startDate, endDate, year);
            const amountForYear = perDayAmount * daysInYear;
            yearRange.push({ year, amountForYear, daysInYear });
        }

        setAmountDetails({
            perDayAmount,
            totalDays,
            amountByYear: yearRange.reduce((acc, { year, amountForYear, daysInYear }) => {
                acc[year] = { amountForYear, daysInYear };
                return acc;
            }, {})
        });
    };

    const formatAmount = amount => {
        const numericAmount = Number(amount);
        if (isNaN(numericAmount)) {
            return amount;
        }
        return numericAmount.toLocaleString();
    };

    const popoverContent = (
        <div>
            <div>Total Days: {amountDetails.totalDays}</div>
            <div>Per Day Amount: $ {formatAmount(amountDetails.perDayAmount.toFixed(2))}</div>
            {Object.entries(amountDetails.amountByYear).map(([year, { amountForYear, daysInYear }]) => (
                <div key={year}>
                    {year} Amount: $ {formatAmount(amountForYear.toFixed(0))} ({daysInYear} days)
                </div>
            ))}
        </div>
    );

    useEffect(() => {
        if (dateRange && dollar !== undefined) {
            calculateAmounts();
        }
    }, [dateRange, dollar]);

    const handleClickOutside = e => {
        if (popoverRef.current && !popoverRef.current.contains(e.target)) {
            setShowPopover(false);
        }
    };

    useEffect(() => {
        if (showPopover) {
            document.addEventListener("click", handleClickOutside);
        } else {
            document.removeEventListener("click", handleClickOutside);
        }

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [showPopover]);

    return (
        <div>
            <OverlayTrigger
                trigger="click"
                placement="bottom"
                show={showPopover}
                overlay={<StyledPopover id="popover-basic">{popoverContent}</StyledPopover>}
            >
                <StyledIcon ref={popoverRef} className="fa fa-info" onClick={() => setShowPopover(!showPopover)} />
            </OverlayTrigger>
        </div>
    );
};
